<template>
  <CContainer class="d-flex align-items-center min-vh-100">
    <section class="page_404">
      <div class="row">
        <div class="col-sm-12 ">
          <div class="col-sm-offset-1  text-center">
            <div class="four_zero_four_bg">
              <h1 class="text-center ">500</h1>
            </div>
            <div class="contant_box_404">
              <h3 class="h2">
                The system is maintenance
              </h3>
              <p>Please visit again later!</p>
              <button @click="$router.push('/').catch(e => {})" class="btn btn-action-primary btn-primary">Go to Home <i class="fa fa-arrow-right"></i></button>
            </div>
          </div>
        </div>
      </div>
    </section>
  </CContainer>
</template>

<script>
  export default {
    name: 'Page500',
  }
</script>
<style scoped>
  .page_404 {
    padding: 40px 0;
    background: #fff;
    width: 100%;
  }

  .page_404 img {
    width: 100%;
  }

  .four_zero_four_bg {
    background-image: url('/static/img/error.gif');
    height: 400px;
    background-position: center;
    background-repeat: no-repeat;
  }


  .four_zero_four_bg h1 {
    font-size: 80px;
  }

  .four_zero_four_bg h3 {
    font-size: 80px;
  }

  .link_404 {
    color: #fff !important;
    padding: 10px 20px;
    background: #39ac31;
    margin: 20px 0;
    display: inline-block;
  }

  .contant_box_404 {
    margin-top: -50px;
  }
</style>
